import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Plus, Minus, MapPin, Package, Home, Trash2 } from 'lucide-react';
import { useCartStore } from '../store/useCartStore';
export function OrderModal() {
  const {
    isCartOpen,
    closeCart,
    items,
    updateQuantity,
    removeItem
  } = useCartStore();
  const [deliveryMethod, setDeliveryMethod] = useState('branch');
  const totalAmount = items.reduce((sum, item) => sum + parseInt(item.product.price) * item.quantity, 0);
  return <AnimatePresence data-id="element-44" data-mp="1ntua1x5wcwf8">
      {isCartOpen && <>
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-45" data-mp="1su039hrteqzf">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeCart} className="fixed inset-0 bg-brand-blueDark/60 backdrop-blur-sm pointer-events-auto" data-id="element-46" data-mp="1wvbn16o0chzp" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="w-full max-w-lg bg-white rounded-3xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col pointer-events-auto relative z-10" data-id="element-47" data-mp="1xzzvq9utjbln">
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-48" data-mp="26xtpbd177r54">
                <h2 className="text-2xl font-black text-brand-blue" data-id="element-49" data-mp="220jutiyycpaf">
                  Кошик та оформлення
                </h2>
                <button onClick={closeCart} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-50" data-mp="vl9d61vx0m3y">
                  <X className="w-6 h-6 text-gray-500" data-id="element-51" data-mp="3eqag0uhonisr" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto custom-scrollbar flex-1" data-id="element-52" data-mp="3isf9nt84sffe">
                {items.length === 0 ? <div className="text-center py-12" data-id="element-53" data-mp="34rkyj2tp80d1">
                    <p className="text-brand-muted font-medium text-lg" data-id="element-54" data-mp="39r7a77tvp8jq">
                      Ваш кошик порожній
                    </p>
                  </div> : <>
                    {/* Cart Items */}
                    <div className="space-y-4 mb-8" data-id="element-55" data-mp="2zu2wzxi0gnf2">
                      {items.map(item => <div key={item.product.id} className="flex items-center gap-4 bg-brand-bg p-4 rounded-2xl border border-gray-100 relative group" data-id="element-56" data-mp="2m36a8narn0fx">
                          <img src={item.product.img} alt={item.product.title} className="w-16 h-16 object-cover rounded-xl border border-gray-200" data-id="element-57" data-mp="2c61hu5qbu8qo" />
                          <div className="flex-grow" data-id="element-58" data-mp="1tgpzutlanmzr">
                            <h3 className="font-bold text-brand-blue leading-tight mb-1 pr-8" data-id="element-59" data-mp="27f632ajy6vd5">
                              {item.product.title}
                            </h3>
                            <p className="text-brand-muted font-medium text-sm mb-3" data-id="element-60" data-mp="22i5wlyj6rqli">
                              {item.product.price} грн
                            </p>
                            <div className="flex items-center gap-4" data-id="element-61" data-mp="2cdr6sjyerx6c">
                              <div className="flex items-center border border-gray-200 rounded-lg overflow-hidden bg-white" data-id="element-62" data-mp="2q5xctd7ukns2">
                                <button type="button" onClick={() => updateQuantity(item.product.id, item.quantity - 1)} className="p-2 hover:bg-gray-50 text-gray-600 transition-colors" data-id="element-63" data-mp="2l7492cid4b53">
                                  <Minus className="w-4 h-4" data-id="element-64" data-mp="128ogd9llgtx6" />
                                </button>
                                <input type="number" value={item.quantity} onChange={e => updateQuantity(item.product.id, parseInt(e.target.value) || 1)} className="w-12 text-center font-bold text-brand-blue border-x border-gray-200 py-2 outline-none text-sm" data-id="element-65" data-mp="1767so3yqewmh" />
                                <button type="button" onClick={() => updateQuantity(item.product.id, item.quantity + 1)} className="p-2 hover:bg-gray-50 text-gray-600 transition-colors" data-id="element-66" data-mp="1zxhswk8pb3sa">
                                  <Plus className="w-4 h-4" data-id="element-67" data-mp="2wo4r0bjm8czm" />
                                </button>
                              </div>
                            </div>
                          </div>
                          <button onClick={() => removeItem(item.product.id)} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors" data-id="element-68" data-mp="2mpxd61kmib1u">
                            <Trash2 className="w-4 h-4" data-id="element-69" data-mp="kwhnb6wd107x" />
                          </button>
                        </div>)}
                    </div>

                    <form className="space-y-6" data-id="element-70" data-mp="2k72ann1zfg98">
                      {/* Recipient Details */}
                      <div data-id="element-71" data-mp="25i65pyv82jcu">
                        <h3 className="font-bold text-brand-blue mb-4 text-lg" data-id="element-72" data-mp="25es26nato43t">
                          Вкажіть дані отримувача
                        </h3>
                        <div className="space-y-4" data-id="element-73" data-mp="2y6lisfusmrlj">
                          <div data-id="element-74" data-mp="334d7z241zzm1">
                            <label className="block text-sm font-bold text-gray-700 mb-1.5" data-id="element-75" data-mp="334mxypp3m6rq">
                              Прізвище, ім'я
                            </label>
                            <input type="text" placeholder="ПІБ" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 outline-none transition-all" data-id="element-76" data-mp="2t5xguz510qcj" />
                          </div>
                          <div data-id="element-77" data-mp="3w0w9jl917n6y">
                            <label className="block text-sm font-bold text-gray-700 mb-1.5" data-id="element-78" data-mp="3qzypt48dil3c">
                              Номер телефону
                            </label>
                            <input type="tel" placeholder="+380" defaultValue="+380" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 outline-none transition-all" data-id="element-79" data-mp="8rr8byusg716" />
                          </div>
                        </div>
                      </div>

                      {/* Delivery */}
                      <div data-id="element-80" data-mp="2tkb2joznengf">
                        <h3 className="font-bold text-brand-blue mb-4 text-lg" data-id="element-81" data-mp="2tjjc0skwrfx0">
                          Спосіб доставки (Нова Пошта)
                        </h3>
                        <div className="space-y-3" data-id="element-82" data-mp="3edi8998aazrd">
                          <label className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${deliveryMethod === 'branch' ? 'border-brand-blue bg-brand-blue/5' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-83" data-mp="3eetk7wbvvdtk">
                            <input type="radio" name="delivery" value="branch" checked={deliveryMethod === 'branch'} onChange={e => setDeliveryMethod(e.target.value)} className="w-5 h-5 text-brand-blue focus:ring-brand-blue" data-id="element-84" data-mp="3secky42d7mvu" />
                            <MapPin className={`w-5 h-5 ${deliveryMethod === 'branch' ? 'text-brand-blue' : 'text-gray-400'}`} data-id="element-85" data-mp="jyssv8dfkaid" />
                            <span className="font-bold text-gray-700" data-id="element-86" data-mp="z0rg3npa3ys2">
                              У відділення
                            </span>
                          </label>

                          <label className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${deliveryMethod === 'postomat' ? 'border-brand-blue bg-brand-blue/5' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-87" data-mp="p1s7240lq14j">
                            <input type="radio" name="delivery" value="postomat" checked={deliveryMethod === 'postomat'} onChange={e => setDeliveryMethod(e.target.value)} className="w-5 h-5 text-brand-blue focus:ring-brand-blue" data-id="element-88" data-mp="1cs64yb5vau71" />
                            <Package className={`w-5 h-5 ${deliveryMethod === 'postomat' ? 'text-brand-blue' : 'text-gray-400'}`} data-id="element-89" data-mp="2gmsu3iexndh2" />
                            <span className="font-bold text-gray-700" data-id="element-90" data-mp="2pnr1maoky34e">
                              У поштомат
                            </span>
                          </label>

                          <label className={`flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all ${deliveryMethod === 'courier' ? 'border-brand-blue bg-brand-blue/5' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-91" data-mp="2kr8y1e4zkatn">
                            <input type="radio" name="delivery" value="courier" checked={deliveryMethod === 'courier'} onChange={e => setDeliveryMethod(e.target.value)} className="w-5 h-5 text-brand-blue focus:ring-brand-blue" data-id="element-92" data-mp="38gl3c2x6zyqo" />
                            <Home className={`w-5 h-5 ${deliveryMethod === 'courier' ? 'text-brand-blue' : 'text-gray-400'}`} data-id="element-93" data-mp="5qpujpplg7r8" />
                            <span className="font-bold text-gray-700" data-id="element-94" data-mp="3ryfqb80hvyn9">
                              Адресна доставка кур'єром
                            </span>
                          </label>
                        </div>

                        {/* Dynamic Delivery Input */}
                        <div className="mt-4" data-id="element-95" data-mp="34c0wg4cz039p">
                          <label className="block text-sm font-bold text-gray-700 mb-1.5" data-id="element-96" data-mp="399sm0rq57daq">
                            {deliveryMethod === 'branch' && 'Місто та номер відділення'}
                            {deliveryMethod === 'postomat' && 'Місто та номер поштомату'}
                            {deliveryMethod === 'courier' && 'Місто, вулиця, будинок, квартира'}
                          </label>
                          <textarea rows={2} placeholder="Введіть дані для доставки..." className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 outline-none transition-all resize-none" data-id="element-97" data-mp="110cpcqm6j71w"></textarea>
                        </div>
                      </div>
                    </form>
                  </>}
              </div>

              <div className="p-6 border-t border-gray-100 bg-gray-50" data-id="element-98" data-mp="1as8wer68u7i9">
                {items.length > 0 && <div className="flex items-center justify-between mb-4" data-id="element-99" data-mp="3ex5txluju1k">
                    <span className="text-lg font-bold text-gray-700" data-id="element-100" data-mp="3vi7ri026wm3g">
                      Всього до сплати:
                    </span>
                    <span className="text-2xl font-black text-brand-blue" data-id="element-101" data-mp="2b16wo4xqwpv7">
                      {totalAmount} грн
                    </span>
                  </div>}
                <button disabled={items.length === 0} className="w-full py-4 bg-brand-blue hover:bg-brand-blueDark disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed text-white rounded-xl font-bold text-base tracking-wide shadow-button transition-colors duration-200" data-id="element-102" data-mp="2k0bypl8in1c4">
                  Підтвердити замовлення
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}